import React from 'react'

const Page2 = () => {
  return <div>This is another Page</div>
}

export default Page2
